export default __webpack_public_path__ + "static/media/ic_payment.8ed639e3.svg";